<template>
  <v-app>
    <v-container>
      <v-row>
        <v-col cols="10" offset="1">
          <v-card class="pa-4" id="maintenance-content">
            <v-row>
              <v-col cols="12">
                <h4 class="d-flex justify-center center" style="color: #333;"><strong>ASSET MAINTENANCE</strong></h4>
                <v-row class="justify-space-between">
                  <v-col cols="8">
                    <p style="color: #333;"><strong>COMPANY:</strong></p>
                    <p style="color: #555;" class="text-sub-2">{{ getCurrentCompany?.name }}</p>
                    <p style="color: #555; width:32%; text-wrap: wrap;" class="text-sub-2">{{ getCurrentCompany?.address }}</p>
                    <p style="color: #555;" class="text-sub-2"><strong>Contact No:</strong> {{ getCurrentCompany?.mobile }}</p>
                    <p style="color: #555;" class="text-sub-2"><strong>Email:</strong> {{ getCurrentCompany?.email }}</p>
                  </v-col>
                  <v-col cols="4" class="text-right">
                    <h4 style="font-weight: normal; color: #333;"><strong>CODE &nbsp;</strong>{{ code }}</h4>
                    <p style="color: #333;" class="text-sub-2"><strong>DATE &nbsp;</strong>{{ formatDateView(maintenance_date) }}</p>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" class="px-4">
                <br>
              </v-col>
            </v-row>

            <v-row class="mb-2">
              <v-col cols="6">
                <p style="color:#333"><strong>Location:</strong> <span style="color:#555">{{ location_name }}</span></p>
              </v-col>
              <v-col cols="6" class="text-right">
                <p style="color:#333"><strong>Supplier:</strong> <span style="color:#555">{{ supplier_name }}</span></p>
              </v-col>
            </v-row>

            <v-table class="mt-1" width="100%">
              <thead>
                <tr>
                  <th style="color: #333;">SN</th>
                  <th style="color: #333;">Code</th>
                  <th style="color: #333;">Asset</th>
                  <th class="text-center" style="color: #333;">Status</th>
                  <th class="text-left" style="color: #333;">Issue</th>
                  <th class="text-left" style="color: #333;">Action Taken</th>
                  <th class="text-right" style="color: #333;">Cost</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, key) in displayDetails" :key="item.asset_register_id || key">
                  <td style="color: #555;">{{ key + 1 }}</td>
                  <td style="color: #555;">{{ item.display_code }}</td>
                  <td style="color: #555;">{{ item.display_name }}</td>
                  <td class="text-center" style="color: #555;">{{ item.display_status }}</td>
                  <td class="text-left" style="color: #555;">{{ item.issue_description || '-' }}</td>
                  <td class="text-left" style="color: #555;">{{ item.action_taken || '-' }}</td>
                  <td class="text-right" style="color: #555;">{{ $numberFormat(item.cost || 0) }}</td>
                </tr>
                <v-divider></v-divider>
              </tbody>
            </v-table>

            <v-row class="py-10">
              <v-col cols="9">
                <p class="text-right" style="color: #555;">TOTAL COST</p>
                <v-row class="font-weight-bold justify-space-between px-3 py-4" v-if="remarks">
                  <p colspan="3" style="color: #333;"><strong>Remarks: {{ remarks }}</strong></p>
                </v-row>
              </v-col>
              <v-col cols="3">
                <p class="text-right" style="color: #555;">{{ $numberFormat(total_cost || 0) }}</p>
              </v-col>
            </v-row>

            <v-row class="pt-5">
              <v-col cols="4">
                <p style="border-top: 1px solid #555; width: 200px; margin: 0 auto; color: #333; text-align:center">
                  <span>Prepared By</span>
                </p>
              </v-col>
              <v-col cols="4"></v-col>
              <v-col cols="4">
                <p style="border-top: 1px solid #555; width: 200px; margin: 0 auto; color: #333; text-align:center">
                  <span>{{ getCurrentCompany?.name || 'Company Name' }}</span>
                </p>
              </v-col>
            </v-row>

            <v-row class="text-center mt-6">
              <v-col cols="12">
                <v-btn color="primary" class="mr-2" @click="printPage">
                  <v-icon left>mdi-printer</v-icon> Print
                </v-btn>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
  </template>

<script>
import formatDateView from "@/plugins/dateFormatView";
import { toast } from "vue3-toastify";
import Axios from "axios";
import { getAssetRegistrationsList } from "@/store/api";

export default {
  data() {
    return {
      id: "",
      code: "",
      maintenance_date: "",
      remarks: "",
      location_name: "",
      supplier_name: "",
      details: [],
      displayDetails: [],
      allAssets: [],
      total_cost: 0,
    };
  },
  methods: {
    formatDateView,
    getAssetObject(row) {
      return row?.asset || row?.assetRegister || row?.asset_register || {};
    },
    normalizeRow(row) {
      const a = this.getAssetObject(row);
      return {
        ...row,
        display_code: a.code || a.asset_code || row.asset_code || "",
        display_name: a.name || a.asset_name || row.asset_name || "",
        display_status:
          a?.asset_status?.name ||
          a?.status?.name ||
          a?.asset_status_name ||
          row?.asset_status_name ||
          row?.status_name ||
          "",
      };
    },
    async loadAssets() {
      try {
        const response = await Axios.get(getAssetRegistrationsList, { params: {} });
        this.allAssets = response.data?.data || [];
      } catch (e) {
        this.allAssets = [];
      }
    },
    async loadDetails() {
      const id = this.$route.params.id;
      if (!id) {
        toast.error("Record ID is required");
        return;
      }
      try {
        if ((this.$store.getters.getAssetLocationsList || []).length === 0) {
          await this.$store.dispatch("getAssetLocationsList");
        }
        if (this.allAssets.length === 0) {
          await this.loadAssets();
        }

        const response = await this.$store.dispatch("getAssetMaintenanceById", id);
        const data = response?.data || {};
        this.id = data.id || "";
        this.code = data.code || "";
        this.maintenance_date = data.maintenance_date || "";
        this.remarks = data.remarks || "";
        this.location_name =
          data.asset_location?.name ||
          data.location?.name ||
          data.asset_location_name ||
          (data.asset_location_id
            ? (this.$store.getters.getAssetLocationsList || []).find(l => l.id === data.asset_location_id)?.name
            : "") ||
          "";
        this.supplier_name =
          data.supplier?.supplier_name ||
          data.supplier_name ||
          "";

        const rawDetails = data.details || [];
        this.details = rawDetails.map(d => ({
          asset_register_id: d.asset_register_id,
          issue_description: d.issue_description || "",
          action_taken: d.action_taken || "",
          cost: d.cost || 0,
          asset: d.assetRegister || d.asset_register || {},
        }));
        this.displayDetails = this.details.map(r => {
          const normalized = this.normalizeRow(r);
          if ((!normalized.display_status || !normalized.display_code || !normalized.display_name) && r.asset_register_id) {
            const a = this.allAssets.find(x => x.id === r.asset_register_id);
            if (a) {
              normalized.display_status =
                normalized.display_status ||
                a?.asset_status?.name ||
                a?.status?.name ||
                a?.asset_status_name ||
                "";
              normalized.display_code = normalized.display_code || a.code || a.asset_code || "";
              normalized.display_name = normalized.display_name || a.name || a.asset_name || "";
            }
          }
          return normalized;
        });
        this.total_cost = this.displayDetails.reduce((s, d) => s + (parseFloat(d.cost) || 0), 0);
      } catch (error) {
        console.error("Failed to fetch maintenance:", error);
        toast.error(error?.response?.data?.message || "Failed to load record");
      }
    },
    async printPage() {
      let printWindow = window.open('', 'PRINT', `width=${screen.width}, height=${screen.height}, left=0, top=0`);
      printWindow.document.write(`
        <!DOCTYPE html>
        <html>
          <head>
            <meta charset="UTF-8">
            <meta name="viewport" content="width=device-width, initial-scale=1.0">
            <meta http-equiv="X-UA-Compatible" content="ie=edge">
            <title>Asset Maintenance</title>
            <link rel="preconnect" href="https://fonts.googleapis.com">
            <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
            <link href="https://fonts.googleapis.com/css2?family=Arimo:ital,wght@0,400..700;1,400..700&display=swap" rel="stylesheet">
            <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.8/dist/css/bootstrap.min.css" rel="stylesheet">
            <link href="https://cdn.jsdelivr.net/npm/@mdi/font@7.4.47/css/materialdesignicons.min.css" rel="stylesheet">
            <style>
              body { font-family: 'Arimo', sans-serif; margin: 0px; }
              .invoice-header { display:flex; justify-content:space-between; align-items:center; border-bottom:2px solid #eee; padding-bottom:10px; }
              .invoice-header img { max-height: 70px; max-width: 150px; }
              .table th, .table td { border: 1px solid #000; padding: 8px; vertical-align: middle; }
              .table th { background-color: #f0f0f0; color: #333; }
              .text-end { text-align: right; }
              .text-center { text-align: center; }
              h4 { font-size: 20px; color: #333; }
              p { font-size: 14px; color: #555; margin: 2px 0; }
              strong { font-weight: bold; color: #333; }
              @page { margin: 0.5in; size: letter; }
              .logo-container { display:flex; align-items:center; }
              .logo-container img { margin-left: 10px; }
            </style>
          </head>
          <body>
            <div class="container-fluid position-relative">
              <div class="invoice-header">
                <div>
                  <h4 class="text-uppercase">${this.getCurrentCompany?.name || 'Company Name'}</h4>
                  <p style="width:65%">${this.getCurrentCompany?.address || ''}</p>
                  <p><i class="mdi mdi-phone-outline"></i> ${this.getCurrentCompany?.mobile || ''}</p>
                  <p><i class="mdi mdi-email-outline"></i> ${this.getCurrentCompany?.email || ''}</p>
                  ${this.getCurrentCompany?.website ? `<p><i class="mdi mdi-web"></i> ${this.getCurrentCompany.website}</p>` : ''}
                </div>
                <div class="logo-container">
                  ${this.getCurrentCompany?.logo_thumb ? `<img src=\"${this.getFileServerUrl + this.getCurrentCompany.logo_thumb}\" alt=\"Logo\" class=\"img-fluid\">` : ''}
                </div>
              </div>
              <h4 class=\"text-center my-4\"><strong>ASSET MAINTENANCE</strong></h4>
              <div class=\"row\">
                <div class=\"col-sm-8\">
                  <p><strong>REFERENCE:</strong></p>
                  <p class=\"text-sub-2\">${this.code}</p>
                  ${this.remarks ? `<p class=\"text-sub-2\"><strong>Remarks:</strong> ${this.remarks}</p>` : ''}
                  <p><strong>Location:</strong> ${this.location_name || ''}</p>
                  <p><strong>Supplier:</strong> ${this.supplier_name || ''}</p>
                </div>
                <div class=\"col-sm-4 text-end\">
                  <h4><strong>DATE ${this.formatDateView(this.maintenance_date)}</strong></h4>
                </div>
              </div>
              <table class=\"table mt-4\">
                <thead>
                  <tr>
                    <th>SN</th>
                    <th>Code</th>
                    <th>Asset</th>
                    <th class=\"text-center\">Status</th>
                    <th>Issue</th>
                    <th>Action Taken</th>
                    <th class=\"text-end\">Cost</th>
                  </tr>
                </thead>
                <tbody>
                  ${this.displayDetails.map((d, key) => `
                    <tr>
                      <td>${key + 1}</td>
                      <td>${d.display_code || ''}</td>
                      <td>${d.display_name || ''}</td>
                      <td class=\"text-center\">${d.display_status || ''}</td>
                      <td>${d.issue_description || '-'}</td>
                      <td>${d.action_taken || '-'}</td>
                      <td class=\"text-end\">${(parseFloat(d.cost || 0)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                    </tr>
                  `).join('')}
                </tbody>
              </table>
              <div class=\"row py-4\">
                <div class=\"col-sm-8 text-end\">
                  <p class=\"text-end\">TOTAL COST</p>
                </div>
                <div class=\"col-sm-4 text-end\">
                  <p><strong>${(parseFloat(this.total_cost || 0)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</strong></p>
                </div>
              </div>
            </div>
          </body>
        </html>
      `);
      printWindow.moveTo(0, 0);
      printWindow.focus();
      await new Promise(resolve => setTimeout(resolve, 500));
      printWindow.print();
      printWindow.close();
    },
  },
  computed: {
    getCurrentCompany() {
      return this.$store.getters.getCurrentCompany || {};
    },
    getFileServerUrl() {
      return this.$store.getters.getFileServerUrl || '';
    },
  },
  mounted() {
    this.loadDetails();
  }
};
</script>

<style scoped>
@media print {
  body * {
    visibility: hidden;
  }
  .v-col.cols-10.offset-1, .v-col.cols-10.offset-1 * {
    visibility: visible;
  }
  .v-btn {
    display: none;
  }
  .v-card {
    border: none !important;
    box-shadow: none !important;
  }
  .v-table {
    width: 100% !important;
    border-collapse: collapse;
  }
  .v-table th, .v-table td {
    border: 1px solid #000;
    padding: 8px;
    text-align: left;
  }
  .v-table th {
    background-color: #f5f5f5;
  }
  .text-right {
    text-align: right !important;
  }
  .text-center {
    text-align: center !important;
  }
  @page {
    margin: 0.5in;
    size: letter;
  }
  .v-col.cols-10.offset-1 {
    width: 100% !important;
    margin: 0 !important;
    padding: 0 !important;
  }
  h4 {
    font-size: 20px !important;
  }
  p {
    font-size: 14px !important;
  }
  strong {
    font-weight: bold;
  }
}
.text-sub-2 {
  font-size: 14px !important;
}
</style>


